import { render } from "./MenuHome.vue?vue&type=template&id=d72fe010&scoped=true&lang=html"
import script from "./MenuHome.vue?vue&type=script&lang=js"
export * from "./MenuHome.vue?vue&type=script&lang=js"

import "./MenuHome.vue?vue&type=style&index=0&id=d72fe010&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d72fe010"]])

export default __exports__